<template>
<div>
    <div v-if="dataForTopSection && dataForTopSection.isTrackData">
        <div class="track-info-top track-header" v-if="dataForTopSection && dataForTopSection.svg && dataForTopSection.info">
            <div class="pt-5">
                <h3 class="font-weight-bold h2 text-white program-name-f-s" v-if="dataForTopSection.name">TRACK | {{dataForTopSection.name}}</h3>
                <div class="d-flex flex-column flex-md-row mt-4 pb-3 track-info-height">
                    <div v-if="dataForTopSection.svg" class="pt-lg-0 text-center mr-3 d-none d-md-block">
                        <img class="track-image-header" :src="dataForTopSection.svg">
                    </div>
                    <div v-if="dataForTopSection.info" class="col col-lg-10 col-xl-7 px-lg-2 text-white p-0 pt-3 pt-md-0 d-none d-md-block">
                        <p>{{dataForTopSection.info}}</p>
                    </div>
                </div>
                <div class=" d-block d-md-none mt-n5">
                    <div class="d-flex flex-column flex-md-row mt-4 pb-3" id="module">
                        <div v-if="dataForTopSection.svg" class="pt-lg-0 text-center mr-3 d-block d-md-none">
                            <img class="track-image-header" :src="dataForTopSection.svg">
                        </div>
                        <div v-if="dataForTopSection.info" class="d-block d-md-none">
                            <div v-if="dataForTopSection.info" class="text-white p-0 pt-3 collapse" id="collapseExample" aria-expanded="false">
                                <p>{{dataForTopSection.info}}</p>
                            </div>
                            <a role="button" class="collapsed float-right" data-toggle="collapse" href="#collapseExample" aria-expanded="false" aria-controls="collapseExample"></a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div v-else-if="dataForTopSection && dataForTopSection.isProgram">
        <div class="track-info-top program pt-5" v-if="dataForTopSection">
            <h3 class="font-weight-bold h2 text-white program-name-f-s">Program of JAX New York</h3>
            <h3 class="text-white h4 mt-4"><span class="font-weight-bold program-day-f-s">Conference Days: October 8 & 9</span></h3>
            <h3 class="text-white h4"><span class="font-weight-bold program-day-f-s">Workshop Days: October 7 & 10</span></h3>
        </div>
    </div>
    <div v-else-if="dataForTopSection && dataForTopSection.isSpeakerListing">
        <div class="track-info-top program pt-5" v-if="dataForTopSection">
            <h3 class="font-weight-bold h2 text-white program-name-f-s">Speakers of JAX New York</h3>
            <h3 class="text-white h4 mt-4"><span class="font-weight-bold program-day-f-s">Conference Days: October 8 & 9</span></h3>
            <h3 class="text-white h4"><span class="font-weight-bold program-day-f-s">Workshop Days: October 7 & 10</span></h3>
        </div>
    </div>
    <div v-else-if="dataForTopSection && dataForTopSection.isSpeakerDetail">
        <div class="track-info-top program pt-5" v-if="dataForTopSection && dataForTopSection.expertName">
            <h3 class="font-weight-bold h2 text-white program-name-f-s" v-if="dataForTopSection.expertName">{{dataForTopSection.expertName}}</h3>
            <h3 class="font-weight-bold h2 text-white program-day-f-s" v-if="dataForTopSection.expertCompany">{{dataForTopSection.expertCompany}}</h3>
        </div>
    </div>
    <div v-else-if="dataForTopSection && dataForTopSection.isSessionDetail">
        <div class="track-info-top program pt-5" v-if="dataForTopSection && dataForTopSection.sessionName">
            <h3 class="font-weight-bold h2 text-white mb-3 program-day-f-s ">Session</h3>
            <h3 class="h2 text-white program-name-f-s" v-if="dataForTopSection.sessionName">{{dataForTopSection.sessionName}}</h3>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "HeaderInfo",
    data() {
        return {
            dataForTopSection: false
        }
    },
    setup() {

    },
    created() {
        this.emitter.on('infoFromChild', (data) => {
            this.dataForTopSection = data;
        })
    },
};
</script>

<style>
.track-info-top {
    min-height: 230px;
}

.program-name-f-s {
    font-size: 50px;
}

.program-day-f-s {
    font-size: 35px;
}

.track-info-top.program {
    margin-bottom: 88px;
}

.track-info-height {
    max-height: 184px;
    height: 184px;
}

.track-image-header {
    max-height: 120px;
}

@media only screen and (max-device-width: 767px) {
    .track-info-height {
        max-height: 0px;
    }

    .program-name-f-s {
        font-size: 30px;
    }

    .program-day-f-s {
        font-size: 24px;
    }

    .track-image-header {
        max-height: 75px;
    }

    #module #collapseExample.collapse:not(.show) {
        display: block;
        height: 5.5rem;
        overflow: hidden;
    }

    #module #collapseExample.collapsing {
        height: 5.5rem;
    }

    #module a.collapsed::after {
        content: '+ Show More';
        color: #ec5f72;
    }

    #module a:not(.collapsed)::after {
        content: '- Show Less';
        color: #ec5f72;
    }
}
</style>
